/* ZEPHIR - "Arma tu look": logica del bloque (marco en snippets/FBT.liquid,
 * estilos en assets/zephir-look.css).
 *
 * TRES ESPACIOS POR SILUETA. La prenda de la ficha ocupa el suyo y en los otros
 * dos se pasan candidatos con las flechas. El total se suma solo con las piezas
 * marcadas y un solo boton las manda al carrito.
 *
 * DE DONDE SALEN LOS CANDIDATOS
 *   1. El snippet imprime un grupo de hasta 24, ya priorizando el color de la
 *      variante que se esta viendo (ver el comentario del snippet).
 *   2. Aqui se anade LA PIEZA DE LA MISMA FAMILIA, que es la que de verdad hace
 *      juego: el catalogo titula <TIPO> <FAMILIA> ("TOP PALERMO" / "FALDA
 *      PALERMO"), asi que se quita el tipo del titulo y se busca la familia en
 *      /search/suggest.json. Se hace por busqueda y no leyendo la coleccion
 *      porque la encuentra este en la posicion que este; comprobado que con
 *      q=palermo devuelve las cuatro piezas de la familia.
 *   Esa pieza va primera en su espacio y lleva el sello "Hace juego".
 *
 * EL CARRITO SE HACE A MANO, con /cart/add.js. No se usa el formulario del tema
 * porque el del bloque anterior estaba roto: comprobado en el navegador que el
 * boton principal de la ficha si mueve /cart.js y el del FBT no. Despues del
 * alta se actualiza el contador del header y se avisa con un enlace al carrito;
 * no se abre el cajon del tema porque su contenido se renderiza en el servidor
 * al cargar la pagina y no tiene forma publica de refrescarse.
 *
 * PEREZOSO: nada de red hasta que el bloque esta cerca de la pantalla. NO se usa
 * IntersectionObserver: en esta tienda no dispara nunca (documentado en
 * zephir-pdp-rl.js). Se mide con getBoundingClientRect en el scroll.
 *
 * Comentarios en ASCII; los textos visibles llevan sus acentos.
 */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-zph-look]');
  if (!raiz) return;

  var cajaSlots = raiz.querySelector('[data-zph-slots]');
  var elTotal   = raiz.querySelector('[data-zph-total]');
  var elBoton   = raiz.querySelector('[data-zph-add]');
  var elAviso   = raiz.querySelector('[data-zph-aviso]');
  if (!cajaSlots || !elTotal || !elBoton) return;

  /* Vocabulario de tipos de prenda. Se usa para dos cosas: quitar el tipo del
   * titulo y quedarse con la familia, y decidir en que espacio cae un
   * candidato. Si aparece un tipo nuevo en el catalogo, se agrega aqui y ya.
   *
   * ESTA LISTA SE SACO DEL CATALOGO, no de memoria: se contaron las primeras
   * palabras de los titulos activos. Asi entraron SWEATER (de las mas
   * frecuentes), VEST, KIMONO y SALIDA, que en la primera version faltaban -- y
   * sin ellas esas prendas no aparecian nunca como candidatas ni resolvian
   * familia. Lo que no este aqui simplemente no se propone, que es el fallo
   * seguro: "TARJETA DE REGALO" y un producto llamado "ZZZ" quedan fuera solos.
   *
   * Se compara ordenado por longitud (ver TODOS_TIPOS) para que "BUTTON UP"
   * gane a "BUTTON" y "VESTIDO" gane a "VEST". */
  var TIPOS = {
    superior: ['TOP', 'BLUSA', 'CAMISA', 'BUTTON UP', 'BODY', 'CROP', 'BUZO', 'SACO',
               'SWEATER', 'SUETER', 'JERSEY', 'HALTER'],
    inferior: ['FALDA', 'PANTALON', 'PANTALÓN', 'SHORT', 'BERMUDA', 'LEGGING', 'JEAN', 'CULOTTE'],
    abrigo:   ['CARDIGAN', 'CHALECO', 'VEST', 'KIMONO', 'CAPA', 'CHAQUETA', 'SALIDA',
               'BLAZER', 'PONCHO', 'RUANA', 'ABRIGO'],
    vestido:  ['VESTIDO', 'ENTERIZO', 'JUMPSUIT'],
    medias:   ['MEDIAS', 'CALCETIN', 'CALCETÍN']
  };
  var PLAN = {
    superior: ['superior', 'inferior', 'abrigo'],
    inferior: ['superior', 'inferior', 'abrigo'],
    abrigo:   ['superior', 'inferior', 'abrigo'],
    vestido:  ['vestido', 'abrigo', 'medias']
  };
  var ETIQUETA = {
    superior: 'Superior', inferior: 'Inferior', abrigo: 'Abrigo',
    vestido: 'Vestido', medias: 'Medias'
  };

  var TODOS_TIPOS = [];
  Object.keys(TIPOS).forEach(function (k) { TODOS_TIPOS = TODOS_TIPOS.concat(TIPOS[k]); });
  TODOS_TIPOS.sort(function (a, b) { return b.length - a.length; });

  var silueta = raiz.getAttribute('data-silueta') || 'superior';
  var color   = (raiz.getAttribute('data-color') || '').toUpperCase();
  var plan    = PLAN[silueta] || PLAN.superior;

  function leerJSON(sel) {
    var s = raiz.querySelector(sel);
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  var fijo = leerJSON('[data-zph-fijo]');
  var pool = leerJSON('[data-zph-pool]') || [];
  if (!fijo) return;

  /* --- utilidades ------------------------------------------------------- */

  /* Los tres origenes de precio no traen el mismo formato: Liquid imprime
   * CENTAVOS (entero), y suggest.json y products.json devuelven la cifra en
   * pesos como texto ("249000.00"). Se normaliza todo a centavos. */
  function aCentavos(v) {
    if (typeof v === 'number') return Math.round(v);
    var f = parseFloat(String(v).replace(/[^0-9.]/g, ''));
    if (isNaN(f)) return 0;
    return Math.round(f * 100);
  }

  /* 2026-10-06: separador de miles con PUNTO ($249.000), como el carrito y el
   * checkout. Pendiente que el formato de moneda de la tienda pase tambien a
   * punto en el admin. */
  function plata(cent) {
    return '$' + Math.round(cent / 100).toLocaleString('es-CO');
  }

  function tipoDe(titulo) {
    var t = (titulo || '').toUpperCase().trim();
    for (var i = 0; i < TODOS_TIPOS.length; i++) {
      if (t.indexOf(TODOS_TIPOS[i] + ' ') === 0 || t === TODOS_TIPOS[i]) {
        var g = Object.keys(TIPOS);
        for (var j = 0; j < g.length; j++) {
          if (TIPOS[g[j]].indexOf(TODOS_TIPOS[i]) >= 0) return g[j];
        }
      }
    }
    return '';
  }

  function familiaDe(titulo) {
    var t = (titulo || '').toUpperCase().trim();
    for (var i = 0; i < TODOS_TIPOS.length; i++) {
      if (t.indexOf(TODOS_TIPOS[i] + ' ') === 0) return t.slice(TODOS_TIPOS[i].length + 1).trim();
    }
    return t;
  }

  /* Color del producto: hoy cada producto es de un solo color y lo lleva en la
   * variante. Si la Fase 3 junta los colores en un producto, esto pasa a
   * depender de la variante elegida. */
  function colorDe(p) {
    var v = (p.v || [])[0];
    return v && v.c ? String(v.c).toUpperCase() : '';
  }

  function disponibles(p) {
    return (p.v || []).filter(function (v) { return v.a; });
  }

  /* --- lo que se esta viendo en la ficha -------------------------------- */

  function seleccionFicha(cual) {
    var sel = cual === 'color' ? '.is-t4s-style__color' : '.is-t4s-name__talla';
    var it = document.querySelector('.t4s-product__info-container ' + sel + ' .t4s-swatch__item.is--selected');
    return it ? (it.getAttribute('data-value') || '') : '';
  }

  /* --- estado ----------------------------------------------------------- */

  var estados = plan.map(function (slot) {
    return { slot: slot, fijo: slot === silueta, cands: [], i: 0, incluir: false, talla: '', tocado: false };
  });

  /* La pieza de la misma familia se guarda aparte porque NO viene en el grupo
   * del snippet: si no, cada vez que repartir() rehace los candidatos (al
   * cambiar de color) desaparecia el "Hace juego". */
  var piezaFamilia = null;

  function repartir() {
    var vistos = {};
    vistos[fijo.h] = true;

    estados.forEach(function (e) { e.cands = []; });

    pool.forEach(function (p) {
      if (vistos[p.h]) return;
      if (!disponibles(p).length) return;
      var t = tipoDe(p.t);
      var e = estados.filter(function (x) { return x.slot === t && !x.fijo; })[0];
      if (!e) return;
      vistos[p.h] = true;
      e.cands.push(p);
    });

    /* Mismo color primero: es el que de verdad combina. Dentro de cada grupo se
     * respeta el orden de la coleccion, que ya es el que la tienda decidio. */
    estados.forEach(function (e) {
      e.cands.sort(function (a, b) {
        var ca = colorDe(a) === color ? 0 : 1;
        var cb = colorDe(b) === color ? 0 : 1;
        return ca - cb;
      });
    });

    // La de la familia siempre primera en su espacio.
    if (piezaFamilia) {
      var e = estados.filter(function (x) { return x.slot === tipoDe(piezaFamilia.t) && !x.fijo; })[0];
      if (e) {
        e.cands = [piezaFamilia].concat(e.cands.filter(function (c) { return c.h !== piezaFamilia.h; }));
        e.i = 0;
      }
    }
  }

  /* Los valores por defecto NO pisan lo que el cliente ya haya tocado: la
   * busqueda de la familia termina despues del primer pintado y sin esto podia
   * deshacerle una talla o un tilde recien puesto. */
  function porDefecto() {
    estados.forEach(function (e) {
      if (e.tocado) return;
      if (e.fijo) {
        e.incluir = true;
        e.talla = seleccionFicha('talla');
        return;
      }
      var p = e.cands[e.i];
      // Solo se marca sola la pieza que hace juego; el resto lo decide el cliente.
      e.incluir = !!(p && p.juego);
      e.talla = p ? primeraTalla(p) : '';
    });
  }

  function primeraTalla(p) {
    var d = disponibles(p);
    return d.length ? d[0].s : '';
  }

  function piezaDe(e) {
    return e.fijo ? fijo : e.cands[e.i];
  }

  function varianteDe(e) {
    var p = piezaDe(e);
    if (!p) return null;
    var v = (p.v || []).filter(function (x) { return x.s === e.talla && x.a; })[0];
    return v || null;
  }

  /* --- la pieza de la misma familia ------------------------------------- */

  function buscarFamilia() {
    var fam = familiaDe(fijo.t);
    if (!fam || fam.length < 3) return Promise.resolve();

    var url = '/search/suggest.json?q=' + encodeURIComponent(fam) +
              '&resources[type]=product&resources[limit]=10';
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var res = ((d.resources || {}).results || {}).products || [];

        // Elegibles: misma familia, otro tipo de prenda y con un espacio libre.
        var elegibles = res.filter(function (p) {
          if (p.handle === fijo.h) return false;
          if (familiaDe(p.title) !== fam) return false;
          var t = tipoDe(p.title);
          if (!t || t === silueta) return false;
          return !!estados.filter(function (x) { return x.slot === t && !x.fijo; })[0];
        });
        if (!elegibles.length) return;

        /* Primero la del MISMO color, que es la que de verdad hace conjunto; si
         * ese color no existe en la otra prenda, la primera elegible. El color
         * se busca en el handle porque hoy es donde vive (falda-palermo-blanco). */
        var clave = color.replace(/\s+/g, '-');
        var cand = elegibles.filter(function (p) {
          return clave && p.handle.toUpperCase().indexOf(clave) >= 0;
        })[0] || elegibles[0];

        // Hace falta el detalle para tener variantes y tallas.
        return fetch('/products/' + cand.handle + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (pd) {
            /* products.js devuelve la foto a TAMANO COMPLETO (medido: 1000x1400
             * para un hueco de ~300px). Se le pide el ancho que hace falta; el
             * resto de candidatos ya vienen redimensionados desde Liquid. */
            var nombres = (pd.options || []).map(function (o) {
              return String(typeof o === 'string' ? o : (o && o.name) || '').toLowerCase();
            });
            var ti = nombres.indexOf('talla');
            if (ti < 0) ti = nombres.indexOf('size');
            var ci = nombres.indexOf('color');
            var f = pd.featured_image || (pd.images || [])[0] || '';
            if (f) f += (f.indexOf('?') >= 0 ? '&' : '?') + 'width=520';

            var pieza = {
              h: pd.handle,
              t: pd.title,
              u: '/products/' + pd.handle,
              img: f,
              juego: true,
              /* Talla y color POR NOMBRE de opcion (2026-10-06): en los productos
               * fusionados la opcion 1 es Color y la 2 Talla. */
              v: (pd.variants || []).map(function (v) {
                var ops = v.options || [v.option1, v.option2, v.option3];
                return { i: v.id, s: ti >= 0 ? ops[ti] : v.option1, c: ci >= 0 ? ops[ci] : v.option2,
                         a: v.available, p: aCentavos(v.price) };
              })
            };
            if (!disponibles(pieza).length) return;
            piezaFamilia = pieza;
            repartir();          // la coloca primera en su espacio
          });
      })
      .catch(function () { /* sin familia: el bloque sigue con los candidatos del snippet */ });
  }

  /* --- pintado ---------------------------------------------------------- */

  function tarjeta(e, idx) {
    var p = piezaDe(e);
    var art = document.createElement('article');
    art.className = 'zph-look__c' + (p ? '' : ' is-vacio');
    art.setAttribute('data-slot', e.slot);
    art.setAttribute('data-idx', idx);

    if (!p) {
      art.innerHTML = '<div class="zph-look__foto"></div>' +
        '<div class="zph-look__info"><span class="zph-look__slot">' + ETIQUETA[e.slot] + '</span>' +
        '<span class="zph-look__precio">Sin pieza disponible</span></div>';
      return art;
    }

    var cent = 0;
    var v = varianteDe(e);
    if (v) cent = aCentavos(v.p);
    else if ((p.v || [])[0]) cent = aCentavos(p.v[0].p);

    var foto = document.createElement('div');
    foto.className = 'zph-look__foto';
    var img = document.createElement('img');
    img.src = p.img || '';
    img.alt = p.t || '';
    img.loading = 'lazy';
    foto.appendChild(img);

    if (e.fijo) {
      foto.insertAdjacentHTML('beforeend', '<span class="zph-look__badge is-suave">Esta prenda</span>');
    } else if (p.juego) {
      foto.insertAdjacentHTML('beforeend', '<span class="zph-look__badge">Hace juego</span>');
    }
    if (!e.fijo && e.cands.length > 1) {
      foto.insertAdjacentHTML('beforeend',
        '<button type="button" class="zph-look__nav is-prev" data-zph-mover="-1" aria-label="Anterior">‹</button>' +
        '<button type="button" class="zph-look__nav is-next" data-zph-mover="1" aria-label="Siguiente">›</button>');
    }

    var info = document.createElement('div');
    info.className = 'zph-look__info';
    info.innerHTML =
      '<span class="zph-look__slot">' + ETIQUETA[e.slot] + '</span>' +
      '<a class="zph-look__nombre" href="' + p.u + '"></a>' +
      '<span class="zph-look__precio">' + plata(cent) + '</span>' +
      '<div class="zph-look__tallas"></div>' +
      '<label class="zph-look__inc"><input type="checkbox" data-zph-inc' +
        (e.incluir ? ' checked' : '') + '><span>Incluir</span></label>';
    info.querySelector('.zph-look__nombre').textContent = p.t;

    var tallas = info.querySelector('.zph-look__tallas');
    var yaVistas = {};
    (p.v || []).forEach(function (vv) {
      if (!vv.s || yaVistas[vv.s]) return;
      yaVistas[vv.s] = true;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'zph-look__talla' + (vv.s === e.talla ? ' is-on' : (vv.a ? '' : ' is-off'));
      b.textContent = vv.s;
      b.setAttribute('data-zph-talla', vv.s);
      if (!vv.a) b.disabled = true;
      tallas.appendChild(b);
    });

    art.appendChild(foto);
    art.appendChild(info);
    return art;
  }

  /* 2026-10-06: un espacio sin pieza ya no se pinta como hueco con "Sin pieza
   * disponible". Y si solo queda la prenda de la ficha, no hay look que armar:
   * el bloque se esconde (vuelve a salir si la busqueda de la familia encuentra
   * una pieza despues). */
  function pintar() {
    cajaSlots.innerHTML = '';
    var extras = 0;
    estados.forEach(function (e, i) {
      if (!piezaDe(e)) return;
      if (!e.fijo) extras++;
      cajaSlots.appendChild(tarjeta(e, i));
    });
    raiz.hidden = extras === 0;
    totalizar();
  }

  function totalizar() {
    var suma = 0, n = 0;
    estados.forEach(function (e) {
      if (!e.incluir) return;
      var v = varianteDe(e);
      if (!v) return;
      suma += aCentavos(v.p);
      n++;
    });
    elTotal.textContent = n ? plata(suma) : '—';
    elBoton.disabled = n === 0;
    elBoton.textContent = n > 1 ? 'Añadir el look' : 'Añadir al carrito';
  }

  /* --- interaccion ------------------------------------------------------ */

  cajaSlots.addEventListener('click', function (ev) {
    var art = ev.target.closest ? ev.target.closest('[data-idx]') : null;
    if (!art) return;
    var e = estados[+art.getAttribute('data-idx')];
    if (!e) return;

    var mover = ev.target.closest('[data-zph-mover]');
    if (mover) {
      var paso = +mover.getAttribute('data-zph-mover');
      if (!e.cands.length) return;
      e.i = (e.i + paso + e.cands.length) % e.cands.length;
      var np = e.cands[e.i];
      e.talla = np ? primeraTalla(np) : '';
      e.tocado = true;
      var idx = +art.getAttribute('data-idx');
      pintar();
      /* La clase va en la tarjeta NUEVA y se quita al frame siguiente: puesta
       * antes de pintar() se perdia con el nodo viejo y la foto nunca hacia el
       * fundido. */
      var nueva = cajaSlots.querySelector('[data-idx="' + idx + '"]');
      if (nueva) {
        nueva.classList.add('is-cambiando');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () { nueva.classList.remove('is-cambiando'); });
        });
      }
      return;
    }

    var chip = ev.target.closest('[data-zph-talla]');
    if (chip && !chip.disabled) {
      e.talla = chip.getAttribute('data-zph-talla');
      e.tocado = true;
      /* En la prenda de la ficha la talla no se guarda aparte: se pulsa su
       * swatch para que manden el precio, la foto y el boton del tema, y no
       * queden dos verdades distintas en la misma pagina. */
      if (e.fijo) {
        var sw = [].slice.call(document.querySelectorAll('.t4s-product__info-container .is-t4s-name__talla .t4s-swatch__item'))
          .filter(function (s) { return s.getAttribute('data-value') === e.talla; })[0];
        if (sw) sw.click();
      }
      if (!e.incluir) e.incluir = true;
      pintar();
      return;
    }
  });

  cajaSlots.addEventListener('change', function (ev) {
    var inc = ev.target.closest ? ev.target.closest('[data-zph-inc]') : null;
    if (!inc) return;
    var art = inc.closest('[data-idx]');
    var e = estados[+art.getAttribute('data-idx')];
    if (!e) return;
    e.incluir = inc.checked;
    e.tocado = true;
    totalizar();
  });

  /* --- al carrito ------------------------------------------------------- */

  function contador(n) {
    var c = document.querySelector('.t4s-site-nav__cart .t4s-count-box') ||
            document.querySelector('[data-cart-count]');
    if (c) c.textContent = n;
  }

  function avisar(txt, enlace) {
    if (!elAviso) return;
    elAviso.hidden = false;
    elAviso.textContent = txt + ' ';
    if (enlace) {
      var a = document.createElement('a');
      a.href = '/cart';
      a.textContent = 'Ver el carrito';
      elAviso.appendChild(a);
    }
  }

  elBoton.addEventListener('click', function () {
    var items = [];
    estados.forEach(function (e) {
      if (!e.incluir) return;
      var v = varianteDe(e);
      if (v) items.push({ id: v.i, quantity: 1 });
    });
    if (!items.length) return;

    elBoton.classList.add('is-cargando');
    elBoton.disabled = true;
    if (elAviso) elAviso.hidden = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('alta rechazada');
        return r.json();
      })
      .then(function () {
        return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (c) {
        contador(c.item_count);
        avisar(items.length > 1 ? 'Listo, el look está en tu carrito.' : 'Listo, la prenda está en tu carrito.', true);
      })
      .catch(function () {
        avisar('No se pudo agregar. Vuelve a intentarlo.', false);
      })
      .then(function () {
        elBoton.classList.remove('is-cargando');
        totalizar();
      });
  });

  /* --- reaccionar a la ficha -------------------------------------------- */

  /* Si cambia el color, cambian los candidatos que combinan; si cambia la talla,
   * cambia la de la prenda fija. Se vuelve a ordenar y a pintar. */
  function vigilarFicha() {
    var info = document.querySelector('.t4s-product__info-container');
    if (!info || !window.MutationObserver) return;
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var nuevoColor = seleccionFicha('color').toUpperCase();
        var nuevaTalla = seleccionFicha('talla');
        var cambio = false;

        if (nuevoColor && nuevoColor !== color) {
          color = nuevoColor;
          /* Al cambiar de color hay que volver a BUSCAR la familia, no solo
           * reordenar: la pieza que hace juego es otra prenda distinta (la falda
           * de ESE color), no la misma reordenada. */
          piezaFamilia = null;
          repartir();
          pintar();
          buscarFamilia().then(function () { porDefecto(); pintar(); });
          return;
        }

        estados.forEach(function (e) {
          if (e.fijo && nuevaTalla && nuevaTalla !== e.talla) { e.talla = nuevaTalla; cambio = true; }
        });
        if (cambio) pintar();
      }, 120);
    }).observe(info, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  /* --- arranque perezoso ------------------------------------------------ */

  var arrancado = false;
  function cerca() {
    var r = raiz.getBoundingClientRect();
    return r.top < window.innerHeight * 2.2;
  }
  function arrancar() {
    if (arrancado || !cerca()) return;
    arrancado = true;
    window.removeEventListener('scroll', arrancar);

    repartir();
    porDefecto();
    pintar();
    vigilarFicha();

    buscarFamilia().then(function () {
      porDefecto();
      pintar();
    });
  }

  window.addEventListener('scroll', arrancar, { passive: true });
  window.addEventListener('resize', arrancar);
  arrancar();
})();
